import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from '@nolimitcity/slot-game/bin/core/translation/Translation';
import {NolimitApplication} from '@nolimitcity/slot-launcher/bin/NolimitApplication';
import {TimelineLite, TweenLite} from 'gsap';
import {BarbarianFuryGameConfig} from '../../BarbarianFuryGameConfig';
import {BarbarianFurySoundConfig} from '../../BarbarianFurySoundConfig';
import {BFGameEvent} from "../../events/BFGameEvent";
import {BarbarianFuryBigWinCountUp} from '../../winpresentation/bigwin/BarbarianFuryBigWinCountUp';
import {BarbarianFuryParsedGameData} from "../../server/data/BarbarianFuryParsedGameData";
import {BarbarianFuryGameModuleConfig} from "../../BarbarianFuryGameModuleConfig";

export class BFFreespinOutroView extends ScreenView {
    private _outroSprite:PIXI.Sprite;
    private _fs_Outro_portrait:PIXI.Sprite;
    private _fs_Outro_landscape:PIXI.Sprite;
    private _orientaiton:string;
    private _totalWin:PIXI.Sprite;
    private _totalWinAmount:number;
    private _totalSpin:PIXI.Sprite;
    private _totalMultiplier:PIXI.Sprite;
    protected _winCountup:BarbarianFuryBigWinCountUp;
    private _totalSpinCount:PIXI.BitmapText;
    private _finalMultiplierCount:PIXI.BitmapText;
    private _outroContainer:PIXI.Container;
    private _contentWrapper:PIXI.Container;

    // font for other languages 
    private _totalWinOtherLang:PIXI.Text;
    private _totalSpinOtherLang:PIXI.Text;
    private _totalMultiplierOtherLang:PIXI.Text;
    private _otherlanguageContainer:PIXI.Container;
    private _langOtherThanEn:boolean = false;

    // sequence being for x,y [[totalSpin],[totalMultiplier],[multipliercount],[totalspin count]].
    private _lanscapeItemPositions:number[][] = [[-290, 0], [250, 0], [229, 100], [-280, 100]];
    private _portraitItemPositions:number[][] = [[0, -32], [0, 169], [0, 275], [0, 69]];

    // sequence being for x,y [[totalSpin],[totalMultiplier],[multipliercount],[totalspin count]]. (for languages other than En)
    private _lanscapeItemPositionsOtherLang:number[][] = [[-270, -20], [247, -20], [229, 100], [-280, 100]];
    private _portraitItemPositionsOtherLang:number[][] = [[0, -35], [0, 170], [-9, 275], [-3, 69]];

    // #315
    private _totalWinBelowStake: boolean = false;

    // to create instace of bigWinCOuntup
    constructor(config:IScreenViewConfig, autoClose:boolean) {
        super(config, autoClose);
        this._winCountup = new BarbarianFuryBigWinCountUp();
    }

    protected initAnimations():void {
        super.initAnimations();
        this._outroContainer = new PIXI.Container();
        this._otherlanguageContainer = new PIXI.Container();
        this._outroContainer.visible = false;
        this._otherlanguageContainer.visible = false;
        this._winCountup.position.set(BarbarianFuryGameConfig.instance.GAME_WIDTH * 0.5, BarbarianFuryGameConfig.instance.GAME_HEIGHT * 0.35);

        this._contentWrapper = new PIXI.Container();

        this._fs_Outro_portrait = new PIXI.Sprite(GameResources.getTextures("FS_Outro_portrait")[0]);
        this._fs_Outro_landscape = new PIXI.Sprite(GameResources.getTextures("FS_Outro_landscape")[0]);

        this._contentWrapper.addChild(this._fs_Outro_landscape, this._fs_Outro_portrait);

        this._totalSpinCount = new PIXI.BitmapText("0", {
            fontName : "NumbersWinCountUp",
            fontSize : 30
        });
        this._finalMultiplierCount = new PIXI.BitmapText("0", {
            fontName : "NumbersWinCountUp",
            fontSize : 30
        });
        // using this check for languages other than en


        //let _slotApi = require("@nolimitcity/game-api");
        //Doing this is a big NO NO. game-api is not a passive object that can be required like this. It needs initializing (witch is done by the launcher). It will then get all options and settings from servers/local storage etc. That it works sometimes is just a fluke.
        //Also this kind of operations should be avoided in this function. There is no guarantee that the api is up and running at this point (although very likely). The only thing we know for sure is that the game assets has been loaded.
        //If you need to modify the view based on language we need to know that the api is initialize which it is in the "getReadyToStart" start up phase.
        // GameModeEvent.CHANGE_MODE is dispatched at this point in time so you might use that if you don't want to override getReadyToStart.

        //So even this is a bit sketchy, though it will work most of the time because the game-api init is pretty fast compared to the game init.
        if(SlotGame.api.options.language !== "en") {
            this._langOtherThanEn = true;
            this.languagesOtherEn();
        }

        this._totalWin = new PIXI.Sprite(GameResources.getTextures("total_win")[0]);
        this._totalSpin = new PIXI.Sprite(GameResources.getTextures("total_spin")[0]);
        this._totalMultiplier = new PIXI.Sprite(GameResources.getTextures("final_multiplier")[0]);

        this._totalWin.anchor.set(0.5);
        this._totalSpin.anchor.set(0.5);
        this._totalMultiplier.anchor.set(0.5);

        this._contentWrapper.addChild(this._totalWin, this._winCountup, this._outroContainer);
        this.addChild(this._contentWrapper);
        if(!this._langOtherThanEn) {
            this._outroContainer.addChild(this._totalSpin, this._totalMultiplier, this._finalMultiplierCount, this._totalSpinCount);
        }
    }

    /**
     * function to show labels in other languages
     */
    private languagesOtherEn():void {
        let fontConfig:TextStyleOptions = {
            fill : ["#fcee0d", "#f08c09"],
            fillGradientStops : [0.3, 0.6],
            fillGradientType : 0,
            fontSize : 65,
            fontFamily : "Open Sans",
            stroke : "#432207",
            strokeThickness : 8
        };
        (this._totalWinOtherLang = new PIXI.Text(Translation.translate("TOTAL WIN"), fontConfig)).visible = false;
        this._totalSpinOtherLang = new PIXI.Text(Translation.translate("TOTAL SPIN"), fontConfig);
        this._totalMultiplierOtherLang = new PIXI.Text(Translation.translate("FINAL MULTIPLIER"), fontConfig);
        this._contentWrapper.addChild(this._totalWinOtherLang, this._winCountup);
        this._contentWrapper.addChild(this._otherlanguageContainer);
        this.addChild(this._contentWrapper);
        this._otherlanguageContainer.addChild(this._totalSpinOtherLang, this._totalMultiplierOtherLang);
        this._otherlanguageContainer.addChild(this._finalMultiplierCount, this._totalSpinCount);

        // #250
        Helper.shrinkTextWidth(Translation.translate("TOTAL WIN"), this._totalWinOtherLang, 500);
        Helper.shrinkTextWidth(Translation.translate("TOTAL SPIN"), this._totalSpinOtherLang, 400);
        Helper.shrinkTextWidth(Translation.translate("FINAL MULTIPLIER"), this._totalMultiplierOtherLang, 400);
        this._totalSpinOtherLang.style.fontSize = Math.min(this._totalSpinOtherLang.style.fontSize, this._totalMultiplierOtherLang.style.fontSize);
        this._totalMultiplierOtherLang.style.fontSize = Math.min(this._totalSpinOtherLang.style.fontSize, this._totalMultiplierOtherLang.style.fontSize);
    }

    /**
     * override this function to create backgrount
     */
    protected createBackground():PIXI.DisplayObject {
        this._outroSprite = new PIXI.Sprite(GameResources.getTextures("bonusBackground")[0]);
        this._outroSprite.anchor.set(0.5);
        this._outroSprite.visible = false;
        return this._outroSprite;
    }

    /**
     * override this function to resize background, outro elements on orientaiton change.
     * @param resizeData
     */
    protected onResize(resizeData:IResizeData):void {
        super.onResize(resizeData);
        this.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
        this._orientaiton = resizeData.orientation;
        this._fs_Outro_landscape.anchor.set(0.5);
        this._fs_Outro_portrait.anchor.set(0.5);
        this._outroSprite.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);

        if(this._langOtherThanEn) {
            this._totalWinOtherLang.anchor.set(0.5);
            this._totalMultiplierOtherLang.anchor.set(0.5);
            this._totalSpinOtherLang.anchor.set(0.5);

        }
        this._outroContainer.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
        this._otherlanguageContainer.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);

        let defaultScaling:number = 0.85,
            marginDiffY:number = 0;

        if(resizeData.orientation === "landscape") {
            for(let index = 0; index < this._outroContainer.children.length; index++) {
                this._outroContainer.children[index].position.set(this._lanscapeItemPositions[index][0], this._lanscapeItemPositions[index][1]);
            }

            this._totalWin.position.set(this._screenWidth * 0.5, this._screenHeight * 0.15);
            this._winCountup.position.set(this._screenWidth * 0.5, BarbarianFuryGameConfig.instance.GAME_HEIGHT * 0.29);
            this._fs_Outro_landscape.position.set(this._screenWidth * 0.5, this._screenHeight * 0.43);
            this._fs_Outro_portrait.visible = false;
            this._fs_Outro_landscape.visible = true;

            if(this._langOtherThanEn) {
                this._totalWinOtherLang.position.set(this._screenWidth * 0.5, this._screenHeight * 0.15);
                for(let index = 0; index < this._otherlanguageContainer.children.length; index++) {
                    this._otherlanguageContainer.children[index].position.set(this._lanscapeItemPositionsOtherLang[index][0], this._lanscapeItemPositionsOtherLang[index][1]);
                }
            }

            defaultScaling = 0.85;
            marginDiffY = 0;

            // fix for 4:3 ratio
            if(resizeData.bottom === 620 && resizeData.width <= 970) {
                defaultScaling = 0.75;
            }
        } else {
            this._totalWin.position.set(this._screenWidth * 0.5, this._screenHeight * 0.28);
            this._winCountup.position.set(this._screenWidth * 0.5, this._screenHeight * 0.36);
            for(let index = 0; index < this._outroContainer.children.length; index++) {
                this._outroContainer.children[index].position.set(this._portraitItemPositions[index][0], this._portraitItemPositions[index][1]);
            }

            this._fs_Outro_portrait.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
            this._fs_Outro_portrait.visible = true;
            this._fs_Outro_landscape.visible = false;

            if(this._langOtherThanEn) {
                this._totalWinOtherLang.position.set(this._screenWidth * 0.5, this._screenHeight * 0.28);
                for(let index = 0; index < this._otherlanguageContainer.children.length; index++) {
                    this._otherlanguageContainer.children[index].position.set(this._portraitItemPositionsOtherLang[index][0], this._portraitItemPositionsOtherLang[index][1]);
                }
            }

            defaultScaling = 0.9;
            marginDiffY = 40;

            // fix for 4:3 ratio
            if(resizeData.bottom <= 730) {
                defaultScaling = 0.8;
                marginDiffY = 65;

                this._totalWin.position.set(this._screenWidth * 0.5, this._screenHeight * 0.20);
                this._winCountup.position.set(this._screenWidth * 0.5, this._screenHeight * 0.31);
                // #181
                if(this._langOtherThanEn) {
                    this._totalWinOtherLang.position.set(this._screenWidth * 0.5, this._screenHeight * 0.20);
                }
            }
        }

        let outroScaling:number = parseFloat((defaultScaling).toFixed(2)),
            contentPosX:number = (this._screenWidth - (this._screenWidth * outroScaling)) / 2,
            contentPosY:number = (this._screenHeight - (this._screenHeight * outroScaling)) / 2;

        this._contentWrapper.scale.set(outroScaling);

        this._contentWrapper.position.set(contentPosX, contentPosY - marginDiffY);
    }

    /**
     * override this function to set button visibility to false,
     * playingOutroAnimation()
     * fade out keypad
     * setting visible to true
     * @param data
     * @param onShowComplete
     */
    protected startPresentation(data:BarbarianFuryParsedGameData, onShowComplete:() => void):void {
        SlotGame.sound.fadeAmbience(0, 100);
        SlotGame.sound.playAmbience(BarbarianFurySoundConfig.instance.MAIN_GAME_AMBIANCE);
        SlotGame.sound.fadeAmbience(1, 2000);
        super.startPresentation(data, onShowComplete);
        this.initializeValuesToMeters(data);
        this._button.visible = false;
        this._winCountup.visible = false;
        this._otherlanguageContainer.alpha = 0;
        this._outroContainer.alpha = 0;
        const sprite:PIXI.Sprite = (this._orientaiton === "landscape") ? this._fs_Outro_landscape : this._fs_Outro_portrait;
        this.playOutroAnimation(sprite, sprite.scale.x);
        SlotGame.keypad.hide();
        this._outroSprite.visible = true;
        if(this._langOtherThanEn) {
            this._totalWinOtherLang.visible = !this._totalWinBelowStake;
            if (this._totalWin) {
                this._totalWin.visible = false;
            }
        } else {
            this._totalWin.visible = !this._totalWinBelowStake;
            if (this._totalWinOtherLang) {
                this._totalWinOtherLang.visible = false;
            }
        }
    }

    /**
     * function to set updated values to meters
     */
    private initializeValuesToMeters(data: BarbarianFuryParsedGameData):void {
        this._totalSpinCount.text = (data.numberOfFreespinsPlayed!).toString();
        this._finalMultiplierCount.text = (data.currentMultiplier).toString();
        this._totalWinAmount = data.totalWin;
        this._totalSpinCount.pivot.set(this._totalSpinCount.width / 2, this._totalSpinCount.height / 2);
        this._finalMultiplierCount.pivot.set(this._finalMultiplierCount.width / 2, this._finalMultiplierCount.height / 2);

        // #315
        this._totalWinBelowStake = BarbarianFuryGameModuleConfig.featurePrice.isWinBelowStake();
    }

    /**
     * override this funciton to fade in keypad, seeting bg to false
     * change bg to normal
     * @param closeCallback
     */
    protected stopPresentation(closeCallback?:() => void):void {
        super.stopPresentation(closeCallback);
        SlotGame.keypad.show();
        this._outroSprite.visible = false;
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : GameMode.NORMAL}));
        EventHandler.dispatchEvent(new GameEvent(BFGameEvent.EXIT_FREESPIN));

        BarbarianFuryGameModuleConfig.featurePrice.reset();
    }

    /**
     * function to play outro animaiton
     * zoom out animaiton will be played
     * then coutup will be played
     * then other label and amount will be visible
     * @param sprite
     * @param to
     */
    private playOutroAnimation(sprite:PIXI.Sprite, to:number) {
        let tl:TimelineLite = new TimelineLite({
            onComplete : () => {
                this._button.visible = true;
            }
        });

        tl.add([
            TweenLite.fromTo(sprite.scale, 0.3, {x : 5, y : 5}, {x : to, y : to}),
            TweenLite.fromTo(this._totalWin.scale, 0.3, {x : 5, y : 5}, {x : 1, y : 1})
        ]);

        tl.add(() => {
            this._winCountup.visible = true;
            // #315
            !this._totalWinBelowStake && this._totalWinAmount > 0 && SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.COUNT_UP);
            this._winCountup.getCountUpAnimation(0, this._totalWinAmount, (this._totalWinBelowStake ? 0 : 0.5));
        }, 0.2);

        tl.add(() => {
            this._langOtherThanEn ? this.playTweenOnOutro(this._otherlanguageContainer) : this.playTweenOnOutro(this._outroContainer);
        }, (this._totalWinBelowStake ? 0.7 : 1.3));

        // #315
        if(!this._totalWinBelowStake) {
            // added this delay to play countup ends sound & stop countup sound
            TweenLite.delayedCall(0.6, () => {
                if (this._totalWinAmount > 0) {
                    SlotGame.sound.stopEffect(BarbarianFurySoundConfig.instance.COUNT_UP);
                    SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.COUNT_UP_ENDS);
                }
            });
        }
    }

    /**
     *
     * @param data override this function to change button position
     */
    protected setButtonPosition(data:IResizeData):void {
        super.setButtonPosition(data);
        //fix done for Continue button for Russian
        //this._button.scale.set(0.8);
        this._button.setSize(307, 82, 0.8);
        this._button.position.set(this._screenWidth * 0.5, this._screenHeight * 0.89);
    }

    /**
     * function to play outro animation.
     * @param Container
     */
    protected playTweenOnOutro(Container:PIXI.Container):void {
        Container.visible = true;
        TweenLite.fromTo(Container, 0.2, {alpha : 0}, {alpha : 1});
    }
}
